import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { ref, getDownloadURL, uploadBytes, getBlob } from "firebase/storage";

export default function FirebaseDownloader({ firebaseStorage }) {
  //   useEffect(() => {
  //     (async () => {
  //       const storage = getStorage(strapi.firebase);

  //       const fileRef = ref(storage, "client_files/yelp_reviews.csv");

  //       const resp = await getDownloadURL(fileRef);
  //     })();
  //   }, []);

  const handleDownload = (e) => {
    // const fileRef = ref(
    //   firebaseStorage,
    //   "client_files/XUBmdPrPMLTqAgauWrymefGs0Yu1/loans/0cf23437b86967d73f01379246530d41/closer/How_To_Invest_In_Real_Estate_1_495d299d99.png_4r3rox"
    // );

    // gs://offer-market-us.appspot.com/client_files/XUBmdPrPMLTqAgauWrymefGs0Yu1/loans/0cf23437b86967d73f01379246530d41/closer/How_To_Invest_In_Real_Estate_1_495d299d99.png_4r3rox
    (async () => {
      // const urlOptions = {
      //   version: "v4",
      //   action: "read",
      //   expires: Date.now() + 1000 * 60 * 2, // 2 minutes
      // };

      const storageRef = ref(
        firebaseStorage, // closer test // // title test //  "client_files/XUBmdPrPMLTqAgauWrymefGs0Yu1/loans/0cf23437b86967d73f01379246530d41/closer/How_To_Invest_In_Real_Estate_1_495d299d99.png_4r3rox"
        // title test
        // `client_files/XUBmdPrPMLTqAgauWrymefGs0Yu1/loans/0cf23437b86967d73f01379246530d41/BorrowingEntity/Best_Howard_County_Porperty_Management_companies_537c881172.png`
        // clien test
        // `client_files/q7TSwARxoehTLqo3DkYxL7AQgSJ3/IDVerification/221 Lawrence St - Sclafani - DSCR Loan Terms - OfferMarket.pdf`
        // agent test
        `client_files/XUBmdPrPMLTqAgauWrymefGs0Yu1/loans/0cf23437b86967d73f01379246530d41/InsuranceVerification/Why_are_you_J_Ving_f3c923ad46.png`

        // `/client_files/XUBmdPrPMLTqAgauWrymefGs0Yu1/loans/0cf23437b86967d73f01379246530d41/closer/How_To_Invest_In_Real_Estate_1_495d299d99.png_4r3rox`
        // "/client_files/loans/0cf23437b86967d73f01379246530d41/d41586-023-03301-1_26200014.gif"
      );

      // const resp = await getDownloadURL(fileRef, urlOptions);
      // const localFilename = "image.jpg";
      // const options = {
      //   destination: localFilename,
      // };

      //
      try {
        // const response = await getBlob(storageRef);

        const blob = await getBlob(storageRef);

        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "myfilename.png";
        link.click();

        // Old code
        // respDataBlob = await response.blob();

        // let a = document.createElement("a");
        // document.body.appendChild(a);
        // a.style = "display: none";
        // let url = window.URL.createObjectURL(respDataBlob);
        // a.href = url;
        // a.download = `Appraisal_Order_${loan.Address}.pdf`;
        // a.click();
        // window.URL.revokeObjectURL(url);
        // return [];
      } catch (e) {
        console.log(e);
      }
    })();

    // Create writable stream to download file
    // const localFilename = 'image.jpg';
    // const options = {
    //   destination: localFilename
    // };

    // const [response] = await file.getStream(options);

    // response
    //   .on('end', () => {
    //     console.log(`File ${localFilename} downloaded.`);
    //   })
    //   .on('error', err => {
    //     console.log('Error downloading file:', err);
    //   });

    //
    // e.preventDefault();
    // const file = e.target[0]?.files[0];

    // const metadata = {
    //   customMetadata: {
    //     // claims: ["appraiser", "title"],
    //     claims: "appraiser,title",
    //     loanID: "1231d12Caw1313",
    //   },
    // };

    // if (!file) return null;
    // const storageRef = ref(firebaseStorage, `client_files/${file.name}`);

    // uploadBytes(storageRef, file, metadata).then((snapshot) => {
    //   e.target[0].value = "";
    //   getDownloadURL(snapshot.ref).then((downloadURL) => {
    //     console.log(downloadURL);
    //   });
    // });
  };

  return (
    <Box>
      {" "}
      <Button
        variant="contained"
        onClick={() => {
          handleDownload();
        }}
      >
        Download
      </Button>
    </Box>
  );
}
